import * as yup from "yup";
import type { PatientEncounter } from "@/resources/types";

// function expect(desc: string, condition: boolean) {
//   if (condition === true) return;

//   console.warn(`PNL4fctT51 | Not satisfied: ${ desc }`);
// }

// #region isValidMedicarePositionNumber

const isValidMedicarePositionNumber = (v: string): boolean => {
  return Boolean(v.match(/^[1-9]\d*$/));
};
const medicarePositionNumberSchema = yup.string().test(
  "isCorrectMedicareNoPos",
  "Must be valid medicare position number",
  v => {
    if (v === undefined || v === "") return true;

    return isValidMedicarePositionNumber(v);
  }
);

// const isValidMedicarePositionNumberPrefix = "isValidMedicarePositionNumber: ";
// expect(`${isValidMedicarePositionNumberPrefix} fails for empty string`, isValidMedicarePositionNumber("") === false);
// expect(`${isValidMedicarePositionNumberPrefix} fails for non-digits`, isValidMedicarePositionNumber("a") === false);
// expect(`${isValidMedicarePositionNumberPrefix} fails for non-digits`, isValidMedicarePositionNumber("1a") === false);
// expect(`${isValidMedicarePositionNumberPrefix} fails for non-digits`, isValidMedicarePositionNumber("1.qwe") === false);
// expect(`${isValidMedicarePositionNumberPrefix} fails for float string`, isValidMedicarePositionNumber("0.12") === false);
// expect(`${isValidMedicarePositionNumberPrefix} fails for float string`, isValidMedicarePositionNumber("1.") === false);
// expect(`${isValidMedicarePositionNumberPrefix} fails for float string`, isValidMedicarePositionNumber("1.2") === false);
// expect(`${isValidMedicarePositionNumberPrefix} fails for int string starting with 0`, isValidMedicarePositionNumber("01") === false);
// expect(`${isValidMedicarePositionNumberPrefix} works for int string`, isValidMedicarePositionNumber("12"));
// expect(`${isValidMedicarePositionNumberPrefix} works for int string`, isValidMedicarePositionNumber("1"));
// expect(`${isValidMedicarePositionNumberPrefix} works for int string`, isValidMedicarePositionNumber("6123"));

// #endregion

// #region isValidMedicareNumber

const medicareNumberRegex = /^[2-6]\d\d\d\d\d\d\d\d\d$/;
const isValidMedicareNumber = (v: string): boolean => {
  if (v.match(medicareNumberRegex) === null) return false;

  const [d1, d2, d3, d4, d5, d6, d7, d8, checkDigit] = v.split("");

  const checksum = 0
    + Number(d1)
    + Number(d2) * 3
    + Number(d3) * 7
    + Number(d4) * 9
    + Number(d5)
    + Number(d6) * 3
    + Number(d7) * 7
    + Number(d8) * 9;
  const calculatedCheckDigit = checksum % 10;

  if (Number(checkDigit) !== calculatedCheckDigit) return false;

  return true;
};
const medicareNumberSchema = yup.string().test(
  "isValidMedicareNumber",
  "Must be valid medicare number",
  v => {
    if (v === undefined || v === "") return true;

    return isValidMedicareNumber(v);
  }
);

export type MedicareSchemaProps = Record<
  Extract<keyof PatientEncounter["patient"], "medicareNo" | "medicareNoPos">,
  yup.AnySchema
>;
export const medicareSchemaProps: MedicareSchemaProps = {
  medicareNo: medicareNumberSchema,
  medicareNoPos: medicarePositionNumberSchema,
};

export const medicareObjSchema = yup.object<MedicareSchemaProps>({
  ...medicareSchemaProps,
});

// const isValidMedicareNumberPrefix = "isValidMedicareNumber: ";
// expect(`${isValidMedicareNumberPrefix} fails for empty string`, isValidMedicareNumber("") === false);
// expect(`${isValidMedicareNumberPrefix} fails for invalid string`, isValidMedicareNumber("qweqwe") === false);
// expect(`${isValidMedicareNumberPrefix} fails for invalid string`, isValidMedicareNumber("123qwe") === false);
// expect(`${isValidMedicareNumberPrefix} fails for invalid string`, isValidMedicareNumber("medicare") === false);
// expect(`${isValidMedicareNumberPrefix} fails for string not starting with [2-6]`, isValidMedicareNumber("0000000000") === false);
// expect(`${isValidMedicareNumberPrefix} fails for string not starting with [2-6]`, isValidMedicareNumber("1000000000") === false);
// expect(`${isValidMedicareNumberPrefix} fails for string not starting with [2-6]`, isValidMedicareNumber("7000000000") === false);
// expect(`${isValidMedicareNumberPrefix} fails for string not starting with [2-6]`, isValidMedicareNumber("8000000000") === false);
// expect(`${isValidMedicareNumberPrefix} fails for string not starting with [2-6]`, isValidMedicareNumber("9000000000") === false);
// expect(`${isValidMedicareNumberPrefix} fails for string with incorrect checksum`, isValidMedicareNumber("2123456731") === false);
// // https://stackoverflow.com/a/15823818/7782182
// expect(`${isValidMedicareNumberPrefix} works for correct number`, isValidMedicareNumber("2123456701") === true);

// #endregion
